import request from '@/utils/request'

// 查询诚意金订单分页
export function pageEarnestMoneyOrder(query) {
  return request({
    url: '/order/earnest-money-order/page',
    method: 'get',
    params: query
  })
}

// 查询诚意金订单详情
export function getEarnestMoneyOrder(data) {
  return request({
    url: '/order/earnest-money-order/detail',
    method: 'get',
    params: data
  })
}

// 新增诚意金订单
export function addEarnestMoneyOrder(data) {
  return request({
    url: '/order/earnest-money-order/add',
    method: 'post',
    data: data
  })
}

// 修改诚意金订单
export function updateEarnestMoneyOrder(data) {
  return request({
    url: '/order/earnest-money-order/edit',
    method: 'post',
    data: data
  })
}

// 删除诚意金订单
export function delEarnestMoneyOrder(data) {
  return request({
    url: '/order/earnest-money-order/delete',
    method: 'post',
    data: data
  })
}
